export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function defaultValue (value, defaultValue) {
  return value != null ? value : defaultValue
}

export function fileSize (bytes, decimals = 0) {
  if (bytes === 0) return '0 Byte'
  let k = 1024
  let dm = decimals + 1 || 2
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export function join (array, delimiter = ', ') {
  return array.join(delimiter)
}

export function prefix (string, prefixer) {
  return `${prefixer}${string}`
}

export function resizeUrl (url, { width, height, mode = 'crop' } = {}) {
  if (url == null) { return '' }
  if (url.indexOf('?') > -1) {
    url += '&'
  } else {
    url += '?'
  }

  const query = []

  if (width) {
    query.push(`width=${width}`)
  }

  if (height) {
    query.push(`height=${height}`)
  }

  if (width && height) {
    query.push(`mode=${mode || 'crop'}`)
  }

  return `${url}${query.join('&')}`
}



// WEBPACK FOOTER //
// ./src/filters/index.js